export default "__VITE_ASSET__DL2oOFDF__"